export default "__VITE_ASSET__hnQF4yb7__"